import type { LucideIcon } from "lucide-react";
import { Bell, Megaphone, Plug } from "lucide-react";

import { FAILED_OUTCOME, parseEventType } from "./event-types";

import { CaptainTokensIcon } from "@/features/captain-billing/constants";

const DOMAIN_ICONS = new Map<string, LucideIcon>([
  ["campaigns", Megaphone],
  ["integrations", Plug],
  ["captain", CaptainTokensIcon],
]);

const OUTCOME_ICONS = new Map<string, LucideIcon>([[FAILED_OUTCOME, Bell]]);

export function getDomainIcon(domain: string): LucideIcon {
  return DOMAIN_ICONS.get(domain) ?? Bell;
}

export function getNotificationIcon(eventType: string): LucideIcon {
  const { domain, outcome } = parseEventType(eventType);
  return OUTCOME_ICONS.get(outcome) ?? getDomainIcon(domain);
}
